import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Grid, Toolbar } from '@mui/material';
import Search from '@mui/icons-material/Search';
import Close from '@mui/icons-material/Close';
import { IconButton, TextField } from '@totalsoft/rocket-ui';

const ChangeFinancialProductToolbarComponent = ({ onFilterValueChanged, fullTextFilter, onResetFilters, disabledStatus }) => {
  const [t] = useTranslation();

  return (
    <Toolbar>
      <Grid item xs={12} sm={12}>
        <TextField
          id={'offerFinancingStructureCard_financialProductChangeModal_filters_fulltext'}
          fullWidth={true}
          name='fullTextFilter'
          disabled={disabledStatus}
          value={fullTextFilter}
          onChange={onFilterValueChanged}
          placeholder={t('Placeholders.FinancialProductSearch')}
          startAdornment={<Search />}
          endAdornment={
            <IconButton
              onClick={onResetFilters}
              disabled={disabledStatus}
              id={'offerFinancingStructureCard_financialProductChangeModal_filters_resetBtn'}
              tooltip={t('Tooltips.ResetFilters')}
              color='primary'
              variant='text'
              size='tiny'
            >
              <Close />
            </IconButton>
          }
        />
      </Grid>
    </Toolbar>
  );
};

ChangeFinancialProductToolbarComponent.propTypes = {
  onFilterValueChanged: PropTypes.func.isRequired,
  onResetFilters: PropTypes.func.isRequired,
  fullTextFilter: PropTypes.string.isRequired,
  disabledStatus: PropTypes.bool.isRequired
};

export default ChangeFinancialProductToolbarComponent;
